import { Box } from '@mui/material';
import React from 'react';

type ConfigTabLabelProps = {
  label: string;
  dirty: boolean;
};

export default function ConfigTabLabel({ label, dirty }: ConfigTabLabelProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {label}
      {dirty && (
        <Box component="span" sx={{ color: 'text.secondary', ml: 0.5 }}>
          *
        </Box>
      )}
    </Box>
  );
}
